import React from 'react';

export default function ClerkLoopDiagnosticScreen({ status, loopGuard, session, isSignedIn, isAuthenticated }) {
    // Defense in depth (Slice F4): the loop guard only trips in development because
    // registerBootstrapMount() short-circuits elsewhere, but that is a guarantee made
    // by a caller. Enforce it locally too, so this diagnostic can never surface
    // internal auth state to a production user even if a future change starts
    // passing a blocked loopGuard in a production build.
    if (process.env.NODE_ENV !== 'development') {
        return (
            <main role="alert" aria-label="Sign-in problem">
                <p>Sign-in could not be completed. Please try again.</p>
            </main>
        );
    }

    const diagnostic = {
        pathname: window.location.pathname,
        clerkState: status?.state || 'unknown',
        configured: status?.configured === true,
        outage: status?.outage === true,
        hasCurrentTask: Boolean(session?.currentTask),
        isSignedIn: isSignedIn === true,
        isAuthenticated: isAuthenticated === true,
        mountCount: loopGuard.count,
        windowMs: loopGuard.windowMs,
        timestamps: loopGuard.timestamps
    };
    return (
        <main role="alert" aria-label="Clerk development loop diagnostic">
            <h1>Clerk authentication loop guard</h1>
            <p>Development-only guard: repeated bootstrap mounts were detected.</p>
            <pre>{JSON.stringify(diagnostic, null, 2)}</pre>
        </main>
    );
}
